<div id="mi-request-details" class="mi-request-details" miFocusOnTab>
    @if (this.formisForm.fields.length> 0) {
    <div id="mi-request-details-content" class="container" tabindex="-1" miFocusOnTab>
        <div class="row justify-content-center">
            <div class=" col-12 mi-panel-wrraper standart">
                <div class="mi-panel-content">
                    <div class="mc-my-3">
                        <span class="mi-header">{{tabsText.requestDetails}}</span>

                    </div>

                    <div class="mi-white-panel with-shadow">
                        <div class="mi-back ">
                            <i class="pi pi-fw pi-chevron-right"></i>
                            <span (click)="moveToProduct()" id="mi-request-details-back" tabindex="0" role="button"
                                (keyup.enter)="moveToProduct()">{{genericText?.back}}
                            </span>
                        </div>


                        <mc-field-form [formisForm]="formisForm">
                        </mc-field-form>


                    </div>
                </div>
                <div class="row justify-content-center     justify-content-md-start">
                    <div class=" mi-next blue-button col-md-3 col-12" id="mi-request-details-next">
                        <mc-button [label]="genericText?.next + ' >'" (click)="next()"></mc-button>
                    </div>

                </div>
            </div>
        </div>


    </div>
    }
    @else{
    <div id="mi-request-details-loaded">
        <mi-genral-skeleton></mi-genral-skeleton>
    </div>
    }
</div>